import { CoreDataCurrency } from '@omnea-app/packages/universal/currency-utils/coreDataCurrency'
import { CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { Dictionary } from '@omnea-app/packages/universal/utility-types/utilityTypes'

type Input = {
  currenciesByCode?: Dictionary<CoreDataCurrency>
  defaultCurrency?: CurrencyCode
}

export const getDefaultFxRate = ({ currenciesByCode, defaultCurrency }: Input): number =>
  currenciesByCode && defaultCurrency ? 1 / (currenciesByCode[defaultCurrency]?.fxRate ?? 1) : 1
